<template>
  <div id="infinite-list" class="main-wrapper scroll-y custom-scrollbar with-tabs view-foodpairing">

    <page-title :title="'Foodpairing'" :back="true"></page-title>

    <iframe id="ksiazece"
            :src="iframe.url"
            width="100%"
            height="100%"
            frameborder="0"
            marginheight="0"
            marginwidth="0"
            scrolling="no">
    </iframe>

  </div>
</template>

<script>
  import PageTitle from '@/components/PageTitle.vue';
  import iframeResize from 'iframe-resizer/js/iframeResizer';

  export default {
    name: 'FoodpairingIndex',
    components: { PageTitle },
    data(){
      return {
        iframe: {
          url: 'https://ksiazece.pl/gastro/'
        }
      }
    },
    mounted(){
      this.resize();
    },
    methods: {
      resize(){
        const el = document.getElementById('infinite-list')
        // vendor method
        iFrameResize({
          onMessage(e) {
            console.log('message', e.message)
            let message = e.message;
            // legacy fix
            if(message == 'openPopup') {
              el.scrollTo(0, 0);
              el.style.overflow = "hidden";
            }
            if(message == 'closePopup') {
              el.style.overflow = "";
            }
          }
        }, '#ksiazece');
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
